import { Button, Form, Space } from 'antd'
import { store } from '~/Store'

{ explore: { memberKeys } } = store.getState()

defaultQueries = {
  'QueryBuilder': [{
    name: 'All'
    query: 'selectOut \'*\''
    fieldName: 'query'
  }, {
    name: 'Types'
    query: "hasRelationIn '#{memberKeys[0]}'"
    fieldName: 'query'
  }]
  'Sparql': [{
    name: 'All'
    query: """
      SELECT DISTINCT ?node FROM DEFAULT
      WHERE {
        ?node ?p ?o .
      }
    """
    fieldName: 'query'
  }]
}

export showDefaultQueries = (queryType, setFieldsValue) ->
  <Form.Item label="Default queries">
    <Space>
      {
        defaultQueries[queryType]?.map((query) ->
          <Button
            key={query.name}
            onClick={->
              setFieldsValue({
                [query.fieldName]: query.query
              })
            }
          >
            { query.name }
          </Button>
        )
      }
    </Space>
  </Form.Item>
